import React, {Component} from 'react'

import NoResultRowComponent from './NoResultRow.component'

class NoResultRowContainer extends Component {
    handleClick = (evt) => {
      evt.preventDefault()

      if (this.props.api) {
        this.props.api.unsetSearch()
        this.props.api.setCustomFilter(null)
        this.props.api.setCustomFilterId(null)
        this.props.api.setCustomFilterType(null)
      }
      this.props.handleFilter({})
      this.props.handleSort(null)   

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'No Result Clear All Filters',
        type: 'Datatable'
      })
    }

    render() {
      const events = {
        handleClick: this.handleClick
      }

      return (
        <NoResultRowComponent events={events} {...this.props} />
      )
    }
}

export default NoResultRowContainer
